import { useCallback, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setIsLoading } from "../slices/holidaySlice";
import { generateRandomString } from "utils/helper";
import * as services from "../services/configBesmartApi";
import { setLoginDevices } from "../slices/attendanceSlice";
import LoginDevices from "../components/LoginDevices";
import { message, Modal } from "antd";


function useLoginDevices() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { currentCompany, currentEmployee, } = useSelector(
    (state) => state.company
  );
  const { loginDevices } = useSelector((state) => state.attendance);
  function toInitialValues(data = {}) {
    const submenu = data?.[0]?.submenu || [];
    const modifiedValues = {
      LoginDevice: data[0]?.statusFlag === "Y",
      maximumNumberToChangeDevice: submenu.find(m => m.menuCode === "MAXIMUM_NUMBER_TO_CHANGE_DEVICE")?.maximumNumberToChangeDevice ?? "0",
    };
    return modifiedValues;
  }
  function toParams(values = {}, loginDevices = []) {
    const menu = loginDevices?.[0] || {};
    const submenu = [
      {
        menuCode: "MAXIMUM_NUMBER_TO_CHANGE_DEVICE",
        maximumNumberToChangeDevice: values.maximumNumberToChangeDevice || 0,
        index: 0,
      },
      {
        menuCode: "ACTION_WHEN_REACH_MAXIMUM_CHANGE",
        actionWhenReachMaximumChange: "LOCK",
        index: 1,
      },
      {
        menuCode: "HOW_TO_UNLOCK",
        howToUnlock: null,
        index: 2,
      },
      {
        menuCode: "MESSAGE_NOTI",
        messageNoti: values.messageNoti || "",
        index: 3,
      },
    ];

    return {
      id: menu?.id,
      menuCode: menu?.menuCode || "LOGIN_DEVICE",
      statusFlag: values?.LoginDevice ? "Y" : "N",
      index: menu?.index ?? 0,
      submenu,
    };
  }
  const updateChangeDevice = useCallback(async (values) => {
    return new Promise((resolve, reject) => {
      Modal.confirm({
        title: t("dialog.confirmation.header"),
        content: (
          <span>{t("dialog.confirmation.edit_action")}</span>
        ),
        async onOk() {
          try {
            dispatch(setIsLoading(true));
            const params = toParams(values, loginDevices);
            const result = await services.editStpBeSmartConfig({
              requestId: generateRandomString(),
              companyId: currentCompany,
              actionId: currentEmployee,
              menuList: params,
            });
            message.success(t("common.successsfull"));
            getLoginBeSmartConfig();
          } catch (error) {
            console.log("catch", error);
          } finally {
            dispatch(setIsLoading(false));
          }
        },
        okText: t("common.confirm"),
        onCancel() {
          resolve(false);
        },
        cancelText: t("common.cancel")
      });
    });
  },
    [currentCompany, currentEmployee, dispatch]
  );

  const getLoginBeSmartConfig = useCallback(async () => {
    try {
      dispatch(setIsLoading(true));
      const response = await services.getBesmartConfig({
        requestId: generateRandomString(),
        companyId: currentCompany,
        actionId: currentEmployee,
        configType: "LOGIN_DEVICE",
      });
      dispatch(setLoginDevices(response.data?.content));
    } catch (error) {
      console.log("catch", error);
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, currentEmployee, dispatch]);

  const initialValues = useMemo(() => {
    return toInitialValues(loginDevices);
  }, [loginDevices]);
  useEffect(() => {
    getLoginBeSmartConfig();
  }, [getLoginBeSmartConfig,]);

  return {
    getLoginBeSmartConfig,
    loginDevices,
    initialValues,
    updateChangeDevice,
  };
}
export default useLoginDevices;
